import {useResourceManagement} from "./resourceHooks";
import {
    AttachmentsQuery,
    createField,
    deleteField,
    editField,
    finalizeField,
    getAttachmentById,
    getAttachmentsArchive,
    uploadAttachments,
} from "../services/fieldService";
import {FieldPostBody} from "../types/domain/field";

export const useFieldManagement = () =>
    useResourceManagement({
        create: (companyId: string, props: FieldPostBody) => createField(companyId, props),
        edit: (companyId: string, id: string, props: FieldPostBody) => editField(companyId, id, props),
        uploadAttachments: (companyId: string, query: AttachmentsQuery, formData: FormData) =>
            uploadAttachments(companyId, query, formData),
        getAttachmentById: (companyId: string, id: string) => getAttachmentById(companyId, id),
        getAttachmentsArchive: (companyId: string, query: AttachmentsQuery) => getAttachmentsArchive(companyId, query),
        finalize: (companyId: string, id: string) => finalizeField(companyId, id),
        delete: (companyId: string, id: string) => deleteField(companyId, id),
    });
